// extracted by mini-css-extract-plugin
export default {"background":"style_background__rdOVc","content":"style_content__3tnns"};